import React, { useContext } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { ModalContext } from '../../../providers/modal'
import { Modal, ModalBody } from 'reactstrap'
import CloseIcon from '@icons/material/CloseIcon'

import './styles.scss'

export default () => {
  const {
    state: { toggled, Content, Title, size },
    dispatch
  } = useContext(ModalContext)
  return (
    <Modal
      isOpen={toggled}
      scrollable
      autoFocus
      centered
      toggle={dispatch.hideModal}
      contentClassName="p-4"
      size={size}
    >
      <button
        onClick={dispatch.hideModal}
        className="align-self-end p-2 modal-close-btn btn btn-outline-dark rounded-circle"
      >
        <CloseIcon />
      </button>
      <div className="modal-header border-bottom-0 p-0 mb-4 pb-2 mt-n2 px-2">
        <div className="modal-title">
          <ReactCSSTransitionGroup
            transitionName="app-modal-title"
            transitionEnterTimeout={0}
            transitionLeaveTimeout={300}
          >
            {Title && <Title />}
          </ReactCSSTransitionGroup>
        </div>
      </div>
      <ModalBody className="pt-0 pb-2 px-2">
        <ReactCSSTransitionGroup
          transitionName="app-modal-content"
          transitionEnterTimeout={0}
          transitionLeaveTimeout={300}
        >
          {Content && <Content />}
        </ReactCSSTransitionGroup>
      </ModalBody>
    </Modal>
  )
}
